import { render, staticRenderFns } from "./UserWelcomeBar.vue?vue&type=template&id=8d156932&"
import script from "./UserWelcomeBar.vue?vue&type=script&lang=js&"
export * from "./UserWelcomeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports